import { readStored, returnPath } from '../firebase/authSession';

export function rememberDestination(location) {
  const path = returnPath(location.pathname + (location.search || '') + (location.hash || ''));
  try { window.sessionStorage.setItem('options.returnTo', path); } catch (_) {}
  return path;
}

export function loginDestination(location) {
  const from = location && location.state && location.state.from;
  if (from) return returnPath(typeof from === 'string' ? from : from.pathname + (from.search || '') + (from.hash || ''));
  try {
    const stored = window.sessionStorage.getItem('options.returnTo');
    if (stored) return returnPath(stored);
  } catch (_) {}
  return returnPath(readStored('previousLocation'));
}

export function consumeDestination(location) {
  const path = loginDestination(location);
  try { window.sessionStorage.removeItem('options.returnTo'); window.localStorage.removeItem('previousLocation'); } catch (_) {}
  return path;
}

export function developmentAddress(href, mode) {
  const url = new URL(href);
  if (mode !== 'development' || !['127.0.0.1', '[::1]'].includes(url.hostname)) return null;
  url.hostname = 'localhost';
  return url.href;
}
